export const sxStyle = {
  dGrid: {
    display: 'inline-flex',
  },

  boxContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    p: '20px',
    m: '10px',
    flexDirection: { xs: 'column', lg: 'row' },
    pt: { xs: '20px', lg: '20px' },
    pb: { xs: '0', lg: '20px' },
  },

  toFlex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  payLink: {
    p: 0,
    color: '#0072ff',
    fontSize: '16px !important',
    '&:hover': {
      bgcolor: '#0000',
    },
  },

  btn: {
    fontSize: '18px',
    bgcolor: '#b0e098',
    width: '200px',
    color: '#000',
    fontWeight: 'bold',
    boxShadow: '0 0.30769em 0.56923em 0 rgb(0 0 0 / 39%)',
    '&:hover': {
      bgcolor: '#93e56b',
    },
    '&:disabled': {
      bgcolor: '#b0e09852',
    },
  },

  barra: {
    height: '30px',
    bgcolor: 'rgb(194, 230, 250)',
  },

  titleBaner: {
    fontSize: '16px',
    m: 0,
    mt: '20px',
  },

  btnAceptar: {
    bgcolor: 'rgb(194, 230, 250)',
    p: '8px 15px',
    cursor: 'pointer',
  },
};
